module.exports = __webpack_public_path__ + "system/img/abbreviation.a562fab6.png";